export const step = {
  GREETING: 1,
  SETTING: 2,
  INTERESTED_INDUSTRIES: 3,
  INTERESTED_LOCATIONS: 4,
}

export const idVietnam = 869
